const ACTION_TYPES = require('actions/Actions').TYPES;
const initialState = { isActive: false };
const reducer = function (state = initialState) {
    return state;
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
